"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgThumbsUpFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M12 26h13.46l.24-.14a11.73 11.73 0 005-7.06 14.75 14.75 0 00-.52-8.18l-.33-.62H22.3l.51-4.3a3.69 3.69 0 00-.57-2.84A4.92 4.92 0 0018.18 1h-2.1l-.08.92a15 15 0 01-2 6 21.54 21.54 0 01-2 2.7zM2 11h8v17H2z" })));
}
exports.default = SvgThumbsUpFilled;
//# sourceMappingURL=ThumbsUpFilled.js.map